import { render, staticRenderFns } from "./staffMoreiphone.vue?vue&type=template&id=0dc7cd73&scoped=true&"
import script from "./staffMoreiphone.vue?vue&type=script&lang=js&"
export * from "./staffMoreiphone.vue?vue&type=script&lang=js&"
import style0 from "./staffMoreiphone.vue?vue&type=style&index=0&id=0dc7cd73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc7cd73",
  null
  
)

export default component.exports